export default __webpack_public_path__ + "static/media/amex.418768cf.svg";